// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

import { __jsr } from '~/lib/utils/path_helpers/core';
import { hasOrganizationScopedPaths } from '~/lib/utils/path_helpers/utils';


/**
 * Generates the Rails route:
 *
 * - href: `/explore/projects/active(.:format)`
 * - Path helper: `active_explore_projects_path`
 * - URL helper: `active_explore_projects_url`
 * - controller#action: `explore/projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeExploreProjectsPath = /*#__PURE__*/ (...args) => {
  const _activeOrganizationExploreProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _activeExploreProjectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _activeOrganizationExploreProjectsPath(gon.current_organization.path, ...args);
  }

  return _activeExploreProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/projects/inactive(.:format)`
 * - Path helper: `inactive_explore_projects_path`
 * - URL helper: `inactive_explore_projects_url`
 * - controller#action: `explore/projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inactiveExploreProjectsPath = /*#__PURE__*/ (...args) => {
  const _inactiveOrganizationExploreProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _inactiveExploreProjectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _inactiveOrganizationExploreProjectsPath(gon.current_organization.path, ...args);
  }

  return _inactiveExploreProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/projects/all(.:format)`
 * - Path helper: `all_explore_projects_path`
 * - URL helper: `all_explore_projects_url`
 * - controller#action: `explore/projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const allExploreProjectsPath = /*#__PURE__*/ (...args) => {
  const _allOrganizationExploreProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _allExploreProjectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _allOrganizationExploreProjectsPath(gon.current_organization.path, ...args);
  }

  return _allExploreProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/projects/topics(.:format)`
 * - Path helper: `topics_explore_projects_path`
 * - URL helper: `topics_explore_projects_url`
 * - controller#action: `explore/projects#topics`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topicsExploreProjectsPath = /*#__PURE__*/ (...args) => {
  const _topicsOrganizationExploreProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _topicsExploreProjectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"topics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _topicsOrganizationExploreProjectsPath(gon.current_organization.path, ...args);
  }

  return _topicsExploreProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/projects/topics/:topic_name(.:format)`
 * - Path helper: `topic_explore_projects_path`
 * - URL helper: `topic_explore_projects_url`
 * - controller#action: `explore/projects#topic`
 *
 * @param {any} topicName
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const topicExploreProjectsPath = /*#__PURE__*/ (...args) => {
  const _topicOrganizationExploreProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"topic_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _topicExploreProjectsPath = /*#__PURE__*/ __jsr.r({"topic_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"topic_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _topicOrganizationExploreProjectsPath(gon.current_organization.path, ...args);
  }

  return _topicExploreProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/projects(.:format)`
 * - Path helper: `explore_projects_path`
 * - URL helper: `explore_projects_url`
 * - controller#action: `explore/projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exploreProjectsPath = /*#__PURE__*/ (...args) => {
  const _organizationExploreProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _exploreProjectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationExploreProjectsPath(gon.current_organization.path, ...args);
  }

  return _exploreProjectsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/groups/active(.:format)`
 * - Path helper: `active_explore_groups_path`
 * - URL helper: `active_explore_groups_url`
 * - controller#action: `explore/groups#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activeExploreGroupsPath = /*#__PURE__*/ (...args) => {
  const _activeOrganizationExploreGroupsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _activeExploreGroupsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _activeOrganizationExploreGroupsPath(gon.current_organization.path, ...args);
  }

  return _activeExploreGroupsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/groups/inactive(.:format)`
 * - Path helper: `inactive_explore_groups_path`
 * - URL helper: `inactive_explore_groups_url`
 * - controller#action: `explore/groups#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inactiveExploreGroupsPath = /*#__PURE__*/ (...args) => {
  const _inactiveOrganizationExploreGroupsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _inactiveExploreGroupsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _inactiveOrganizationExploreGroupsPath(gon.current_organization.path, ...args);
  }

  return _inactiveExploreGroupsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/groups(.:format)`
 * - Path helper: `explore_groups_path`
 * - URL helper: `explore_groups_url`
 * - controller#action: `explore/groups#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exploreGroupsPath = /*#__PURE__*/ (...args) => {
  const _organizationExploreGroupsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _exploreGroupsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"groups"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationExploreGroupsPath(gon.current_organization.path, ...args);
  }

  return _exploreGroupsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/catalog(.:format)`
 * - Path helper: `explore_catalog_index_path`
 * - URL helper: `explore_catalog_index_url`
 * - controller#action: `explore/catalog#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exploreCatalogIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationExploreCatalogIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"catalog"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _exploreCatalogIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"catalog"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationExploreCatalogIndexPath(gon.current_organization.path, ...args);
  }

  return _exploreCatalogIndexPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/catalog/cells(.:format)`
 * - Path helper: `explore_catalog_cells_path`
 * - URL helper: `explore_catalog_cells_url`
 * - controller#action: `explore/catalog#cells`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exploreCatalogCellsPath = /*#__PURE__*/ (...args) => {
  const _organizationExploreCatalogCellsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"cells"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _exploreCatalogCellsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[6,"cells"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationExploreCatalogCellsPath(gon.current_organization.path, ...args);
  }

  return _exploreCatalogCellsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/catalog/*full_path(.:format)`
 * - Path helper: `explore_catalog_path`
 * - URL helper: `explore_catalog_url`
 * - controller#action: `explore/catalog#show`
 *
 * @param {any} fullPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exploreCatalogPath = /*#__PURE__*/ (...args) => {
  const _organizationExploreCatalogPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"full_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[5,[3,"full_path"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _exploreCatalogPath = /*#__PURE__*/ __jsr.r({"full_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"catalog"],[2,[7,"/"],[2,[5,[3,"full_path"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationExploreCatalogPath(gon.current_organization.path, ...args);
  }

  return _exploreCatalogPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/snippets(.:format)`
 * - Path helper: `explore_snippets_path`
 * - URL helper: `explore_snippets_url`
 * - controller#action: `explore/snippets#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exploreSnippetsPath = /*#__PURE__*/ (...args) => {
  const _organizationExploreSnippetsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"snippets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _exploreSnippetsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"snippets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationExploreSnippetsPath(gon.current_organization.path, ...args);
  }

  return _exploreSnippetsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore/analytics_dashboards(/*vueroute)(.:format)`
 * - Path helper: `explore_analytics_dashboards_path`
 * - URL helper: `explore_analytics_dashboards_url`
 * - controller#action: `explore/analytics_dashboards#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exploreAnalyticsDashboardsPath = /*#__PURE__*/ (...args) => {
  const _organizationExploreAnalyticsDashboardsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"analytics_dashboards"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]);
  const _exploreAnalyticsDashboardsPath = /*#__PURE__*/ __jsr.r({"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"explore"],[2,[7,"/"],[2,[6,"analytics_dashboards"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationExploreAnalyticsDashboardsPath(gon.current_organization.path, ...args);
  }

  return _exploreAnalyticsDashboardsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/explore(.:format)`
 * - Path helper: `explore_root_path`
 * - URL helper: `explore_root_url`
 * - controller#action: `explore/projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exploreRootPath = /*#__PURE__*/ (...args) => {
  const _organizationExploreRootPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"explore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);
  const _exploreRootPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"explore"],[1,[2,[8,"."],[3,"format"]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationExploreRootPath(gon.current_organization.path, ...args);
  }

  return _exploreRootPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/public(.:format)`
 * - Path helper: `public_path`
 * - URL helper: `public_url`
 * - controller#action: `explore/projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publicPath = /*#__PURE__*/ (...args) => {
  const _organizationPublicPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"public"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);
  const _publicPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"public"],[1,[2,[8,"."],[3,"format"]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationPublicPath(gon.current_organization.path, ...args);
  }

  return _publicPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/public/projects(.:format)`
 * - Path helper: `public_projects_path`
 * - URL helper: `public_projects_url`
 * - controller#action: `explore/projects#index`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publicProjectsPath = /*#__PURE__*/ (...args) => {
  const _organizationPublicProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _publicProjectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationPublicProjectsPath(gon.current_organization.path, ...args);
  }

  return _publicProjectsPath(...args);
};

